/* eslint-disable indent,react/jsx-indent,react/jsx-indent-props,max-len */
import React from 'react';
import { connectInfiniteHits } from 'react-instantsearch-dom';
import { InfiniteHitsProvided } from 'react-instantsearch-core';
import PuppyCard from '../../body/card/puppy-card';
import NoResultsSVG from '../../svgComponents/NoResultsSVG';

interface Props extends InfiniteHitsProvided {
  hybrid?: boolean,
  breedSlug?: string,
  listingsType: string,
  setSearchState: (args: any) => void,
}

const InfiniteHits: React.FC<Props> = ({
                                         hits,
                                         hasMore,
                                         hybrid,
                                         breedSlug,
                                         listingsType,
                                         setSearchState,
                                       }) => {
  return (
    <div className="d-flex flex-column">
      <div className="ais-InfiniteHits">
        <ul className="ais-InfiniteHits-list">
          {hits.map((hit) => (
            <li key={hit.objectID} className="ais-InfiniteHits-item">
              <div className="react-puppy-card">
                <PuppyCard algpuppy={hit} key={hit.objectID} />
              </div>
            </li>
          ))}
        </ul>
        {hasMore && (
          <button
            className="ais-InfiniteHits-loadMore"
            disabled={!hasMore}
            onClick={() => {
              setSearchState(
                (s) => ({
                  ...s,
                  page: (s.page || 1) + 1,
                }),
              );
            }}
          >
            Load More
          </button>
        )}
      </div>
    </div>
  );
};

const CustomRenderListingInfiniteHits = connectInfiniteHits(InfiniteHits);
export default CustomRenderListingInfiniteHits;
